"use strict";
import { jsx } from "react/jsx-runtime";
import { emailService } from "../services/email_service";
import WaitingSpinner from "../components/waiting_spinner";
function closeReply(props) {
  emailService.markComplete(null, false, props.emailId).then(() => {
    props.onComplete();
  });
}
function CloseReply(props) {
  const closingReply = false;
  return /* @__PURE__ */ jsx(WaitingSpinner, { when: closingReply, "data-component": "CloseReply", children: /* @__PURE__ */ jsx("button", { className: "button--progress", onClick: () => closeReply(props), children: "Close Reply" }) });
}
export default CloseReply;
